import { AccountUserApiV2 } from '../../../../../../lib/api/account/user/AccountUserApiV2';
import { UserGradesOptions, UserGradesRepositoryType, UserGradesResponseType } from '../types';

export const UserGradesRepository: UserGradesRepositoryType = {
  getUserGrades: (options: UserGradesOptions): Promise<UserGradesResponseType> => {
    return AccountUserApiV2.getAccountUserGrades(options);
  },
};
